import * as React from "react";
const sizes = {
    xs: 16,
    sm: 20,
    md: 20,
    lg: 24,
    xl: 36,
};
function SvgTime(props) {
    return (React.createElement("svg", Object.assign({ width: sizes[props.size || "lg"], height: sizes[props.size || "lg"], viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M23 11.999C23 18.074 18.074 22.998 11.999 22.998C5.92402 22.998 1 18.074 1 11.999C1 5.92599 5.92402 1 11.999 1C18.074 1 23 5.92599 23 11.999ZM11.075 4.99902C11.075 4.48816 11.4891 4.07402 12 4.07402C12.5109 4.07402 12.925 4.48816 12.925 4.99902V11.999C12.925 12.2811 12.7963 12.5477 12.5755 12.7232L7.66195 16.6282C7.26201 16.9461 6.68012 16.8795 6.36227 16.4796C6.04442 16.0796 6.11097 15.4977 6.51091 15.1799L11.075 11.5526V4.99902Z", fill: "currentColor" })));
}
export default SvgTime;
